import {
  useV2CreatePhaseMutation,
  useV2UpdatePhaseMutation,
  useV2DeletePhaseMutation,
  useV2RestorePhaseByIdMutation,
  useV2PurgePhaseByIdMutation,
  useV2ChangePhasePositionByIdMutation,
} from "@generated";
import type { PhaseFormValues } from "../types/Phase";

const phaseAttributes = (values: PhaseFormValues) => ({
  name: values.name,
  "sow-language": values.sowLanguage,
  default: values.isDefault,
});

export const usePhaseMutations = () => {
  const [create, createState] = useV2CreatePhaseMutation();
  const [update, updateState] = useV2UpdatePhaseMutation();
  const [destroy, destroyState] = useV2DeletePhaseMutation();
  const [restore, restoreState] = useV2RestorePhaseByIdMutation();
  const [purge, purgeState] = useV2PurgePhaseByIdMutation();
  const [move, moveState] = useV2ChangePhasePositionByIdMutation();

  return {
    create: (values: PhaseFormValues) =>
      create({
        body: {
          data: {
            type: "phases",
            attributes: phaseAttributes(values),
          },
        },
      }).unwrap(),

    update: (id: string, values: PhaseFormValues) =>
      update({
        id: Number(id),
        body: {
          data: {
            type: "phases",
            id: Number(id),
            attributes: phaseAttributes(values),
          },
        },
      }).unwrap(),

    destroy: (id: string) => destroy({ id: Number(id) }).unwrap(),
    restore: (id: string) => restore({ id: Number(id) }).unwrap(),
    purge: (id: string) => purge({ id: Number(id) }).unwrap(),
    move: (id: string, position: number) =>
      move({
        id: Number(id),
        body: {
          data: {
            type: "phases",
            id: Number(id),
            attributes: { position },
          },
        } as Parameters<typeof move>[0]["body"],
      }).unwrap(),

    states: {
      createState,
      updateState,
      destroyState,
      restoreState,
      purgeState,
      moveState,
    },
  };
};
